import React, { useState, useEffect, useRef } from 'react';
import { TrendingUp, AlertTriangle, Shield, ArrowRight, Search, Check, Loader2, Upload, Star, X, ChevronDown } from 'lucide-react';
import { ReactComponent as WeChatIconSvg } from '../exchange-app-icons/wechat-7.svg';
import { track } from '../utils/tracker';

// СБП Icon Component
const SBPIcon = ({ className = "w-8 h-8" }) => (
  <svg className={className} viewBox="0 0 97 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 26.12l14.532 25.975v15.844L.017 93.863 0 26.12z" fill="#5B57A2"/>
    <path d="M55.797 42.643l13.617-8.346 27.868-.026-41.485 25.414V42.643z" fill="#D90751"/>
    <path d="M55.72 25.967l.077 34.39-14.566-8.95V0l14.49 25.967z" fill="#FAB718"/>
    <path d="M97.282 34.271l-27.869.026-13.693-8.33L41.231 0l56.05 34.271z" fill="#ED6F26"/>
    <path d="M55.797 94.007V77.322l-14.566-8.78.008 51.458 14.558-25.993z" fill="#63B22F"/>
    <path d="M69.38 85.737L14.531 52.095 0 26.12l97.223 59.583-27.844.034z" fill="#1487C9"/>
    <path d="M41.24 120l14.556-25.993 13.583-8.27 27.843-.034L41.24 120z" fill="#017F36"/>
    <path d="M.017 93.863l41.333-25.32-13.896-8.526-12.922 7.922L.017 93.863z" fill="#984995"/>
  </svg>
);

// ВТБ Icon Component
const VTBIcon = ({ className = "w-8 h-8" }) => (
  <svg className={className} viewBox="0 0 92 33" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <path d="M6.25065367,0 L4.68701481,4.28311036 L26.3555573,4.28311036 L27.9191962,0 L6.25065367,0 Z M3.90470765,6.423693 L2.34106879,10.7058308 L24.0096113,10.7058308 L25.5732502,6.423693 L3.90470765,6.423693 Z M1.56363886,12.847386 L0,17.1295238 L21.6685425,17.1295238 L23.231206,12.847386 L1.56363886,12.847386 Z" fill="#38BDF8"/>
        <path d="M46.0659305,18.7617116 L46.0659305,18.8520825 C47.0561913,19.215552 48.002112,19.8511271 48.497735,20.2592855 C50.0289442,21.5304356 50.7048834,23.2097442 50.7048834,25.3885751 C50.7048834,28.975602 48.8130419,31.5625912 45.7052982,32.3799011 C44.7593775,32.6520067 43.7691167,32.7433706 41.9216153,32.7433706 L32.5097041,32.7433706 L32.5097041,6.50603633 L40.8416891,6.50603633 C42.5532145,6.50603633 43.7237914,6.59640716 44.7593775,6.86851275 C47.7774558,7.68582259 49.7589627,9.77428262 49.7589627,13.0872178 C49.7589627,14.8578903 49.1283488,16.3564572 48.0927627,17.3545087 C47.642465,17.808349 47.0118512,18.3535533 46.0659305,18.7617116 Z M37.7339454,21.5304356 L37.7339454,28.4303977 L41.3373122,28.4303977 C42.4172384,28.4303977 43.4084845,28.3400269 44.129749,27.6587698 C44.8500282,26.9775128 45.1653351,26.1155141 45.1653351,24.9804167 C45.1653351,24.118418 44.9396936,23.3011081 44.489396,22.711215 C43.7237914,21.7578524 42.7778706,21.5304356 41.1569961,21.5304356 L37.7339454,21.5304356 Z M37.6886201,16.9910392 L40.6160476,16.9910392 C41.516643,16.9910392 41.9669407,16.9910392 42.4172384,16.8549864 C43.634126,16.4915169 44.3997305,15.4030945 44.3997305,13.9045276 C44.3997305,12.1348482 43.5888006,11.3622273 42.4172384,10.9997508 C41.9216153,10.863698 41.4269776,10.8180161 40.4357315,10.8180161 L37.6886201,10.8180161 L37.6886201,16.9910392 Z M58.5412454,32.7433706 L58.5412454,10.9083869 L51.0201903,10.9083869 L51.0201903,6.50603633 L71.918141,6.50603633 L70.4322572,10.9083869 L63.7654868,10.9083869 L63.7654868,32.7433706 L58.5412454,32.7433706 Z M73.5390156,32.7433706 L73.5390156,6.50603633 L90.4739526,6.50603633 L88.9880688,10.9083869 L78.7189169,10.9083869 L78.7189169,16.7189336 L82.9075721,16.7189336 C86.2852974,16.7189336 88.0421481,17.5362434 89.2580504,18.5799769 C90.2039711,19.3972867 91.8248457,21.2126481 91.8248457,24.799675 C91.8248457,28.3400269 90.1586457,30.291441 88.7624273,31.2904856 C87.1415527,32.4245899 85.4300274,32.7433706 81.9616514,32.7433706 L73.5390156,32.7433706 Z M78.7189169,28.3400269 L82.6375906,28.3400269 C84.1234744,28.3400269 85.0240698,27.9765574 85.6546836,27.1592475 C85.9699905,26.7510892 86.4202882,26.0241502 86.4202882,24.6626291 C86.4202882,23.3011081 85.9699905,22.3477455 85.0693951,21.6664884 C84.5294321,21.2583301 83.8081675,21.0319064 82.5922652,21.0319064 L78.7189169,21.0319064 L78.7189169,28.3400269 Z" fill="#60A5FA"/>
      </g>
    </g>
  </svg>
);

// USDT Icon
const USDTIcon = ({ className = "w-8 h-8" }) => (
  <svg className={className} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" fill="#26A17B"/>
    <path d="M17.922 17.383v-.002c-.11.008-.677.042-1.942.042-1.01 0-1.721-.03-1.971-.042v.003c-3.888-.171-6.79-.848-6.79-1.658 0-.809 2.902-1.486 6.79-1.66v2.644c.254.018.982.061 1.988.061 1.207 0 1.812-.05 1.925-.06v-2.643c3.88.173 6.775.85 6.775 1.658 0 .81-2.895 1.485-6.775 1.657m0-3.59v-2.366h5.414V7.819H8.595v3.608h5.414v2.365c-4.4.202-7.709 1.074-7.709 2.118 0 1.044 3.309 1.915 7.709 2.118v7.582h3.913v-7.584c4.393-.202 7.694-1.073 7.694-2.116 0-1.043-3.301-1.914-7.694-2.117" fill="white"/>
  </svg>
);

// WeChat Icon
const WeChatIcon = ({ className = "w-8 h-8" }) => (
  <WeChatIconSvg className={className} style={{ fill: '#51C332' }} />
);

// TRC-20 (TRON) Icon
const TronIcon = ({ className = "w-10 h-10" }) => (
  <img 
    src="/tron-logo.png" 
    alt="TRC-20" 
    className={`${className} rounded-full object-cover`}
  />
);

// Bybit Icon
const BybitIcon = ({ className = "w-10 h-10" }) => (
  <img 
    src="/bybit-logo.png" 
    alt="Bybit" 
    className={`${className} rounded-lg object-cover`}
  />
);

// Проверка ночного времени (0:00 - 8:30 МСК)
const useNightTimeWarning = () => {
  const [isNightTime, setIsNightTime] = useState(false);

  useEffect(() => {
    const checkTime = () => {
      const now = new Date();
      // Московское время (UTC+3)
      const msk = new Date(now.getTime() + (now.getTimezoneOffset() + 180) * 60000);
      const totalMinutes = msk.getHours() * 60 + msk.getMinutes();
      setIsNightTime(totalMinutes < 510); // 0:00 - 8:30 МСК (8*60+30=510)
    };

    checkTime();
    const interval = setInterval(checkTime, 60000);
    return () => clearInterval(interval);
  }, []);

  return isNightTime;
};

const NightTimeWarning = () => (
  <div className="bg-amber-500/10 rounded-2xl p-4 mb-4 border border-amber-500/30 flex items-start gap-3">
    <AlertTriangle className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
    <p className="text-sm text-amber-300">
      В период с 0:00 до 8:30 могут возникнуть задержки в обработке заявки
    </p>
  </div>
);

const WechatScreen = ({
  wechatPaymentMethod, 
  setWechatPaymentMethod,
  wechatAmount,
  setWechatAmount,
  wechatFullName,
  setWechatFullName,
  wechatQrCode,
  setWechatQrCode,
  wechatSelectedBank,
  setWechatSelectedBank,
  wechatUsdtNetwork,
  setWechatUsdtNetwork,
  exchangeRate,
  usdtToCnyRate,
  handleWechatDeposit,
  limits,
  paymentLimits,
  verificationStatus,
  sbpBanks,
  setCurrentScreen,
  setProfileActiveSection,
  calculateAmount,
  calculatedAmount,
  isSubmitting,
}) => {
  const isNightTime = useNightTimeWarning();
  const [showKycModal, setShowKycModal] = useState(false);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [bankSearch, setBankSearch] = useState('');
  const debounceRef = useRef(null);

  // Согласия с документами
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

  // Чеклист перед созданием заявки
  const [showChecklist, setShowChecklist] = useState(false);
  const [checkPhone, setCheckPhone] = useState(false);
  const [checkVerified, setCheckVerified] = useState(false);
  const [checkQr, setCheckQr] = useState(false);
  const allChecked = checkPhone && checkVerified && checkQr;

  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    if (wechatAmount && parseFloat(wechatAmount) > 0 && calculateAmount && wechatPaymentMethod) {
      debounceRef.current = setTimeout(() => {
        calculateAmount(wechatAmount, 'wechat', wechatPaymentMethod);
      }, 500);
    }
    
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [wechatAmount, calculateAmount, wechatPaymentMethod]);
  
  const isAdmin = verificationStatus?.isAdmin || false;
  const isVerified = verificationStatus?.isVerified || isAdmin || false;
  const isVerificationLoading = verificationStatus?.isLoading || false;

  // Оплата USDT идёт мимо Altyn, поэтому KYC для неё не нужен — вместо него
  // на сервере стоит кулдаун: 1 заявка в 5 минут для неверифицированных.
  const kycRequired = wechatPaymentMethod !== 'USDT';
  const canCreateOrder = isVerified || !kycRequired;

  const banks = sbpBanks?.length > 0 
    ? sbpBanks.filter(b => b.id !== 'vtb' && b.name !== 'ВТБ') 
    : [
      { id: 'tinkoff', name: 'Т-Банк' },
      { id: 'sber', name: 'Сбербанк' },
      { id: 'alfa', name: 'Альфа Банк' },
      { id: 'raif', name: 'Райффайзен Банк' },
      { id: 'gazprom', name: 'Газпромбанк' },
      { id: 'ozon', name: 'Озон Банк' },
      { id: 'rosbank', name: 'Росбанк' },
      { id: 'psb', name: 'ПСБ' },
      { id: 'mts', name: 'МТС Банк' },
      { id: 'sovkom', name: 'Совкомбанк' },
    ];

  const filteredBanks = banks.filter(bank => 
    bank.name.toLowerCase().includes(bankSearch.toLowerCase())
  );

  const getCurrentLimits = () => {
    if (wechatPaymentMethod === 'RUB_SBP' && paymentLimits?.sbp) return paymentLimits.sbp;
    if (wechatPaymentMethod === 'RUB_VTB' && paymentLimits?.vtb) return paymentLimits.vtb;
    return null;
  };

  const currentLimits = getCurrentLimits();
  
  // Минимальная сумма (в рублях)
  const MIN_AMOUNT_RUB = 2000;
  // Минимум для USDT: поле ввода в этом методе — сразу в USDT, рублёвый порог
  // к нему не применяется (то же значение проверяет сервер, USDT_MIN_AMOUNT).
  const MIN_AMOUNT_USDT = 10;
  
  // Проверка лимитов
  const getAmountValidation = () => {
    if (!wechatAmount || !wechatPaymentMethod) return null;
    
    const amountValue = parseFloat(wechatAmount);
    if (isNaN(amountValue) || amountValue <= 0) return null;
    
    // У USDT лимитов нет — только минимум, и он в USDT
    if (wechatPaymentMethod === 'USDT') {
      if (amountValue < MIN_AMOUNT_USDT) {
        return {
          type: 'min',
          message: `Минимальная сумма: ${MIN_AMOUNT_USDT} USDT`
        };
      }
      return null;
    }
    
    // Проверка минимальной суммы
    if (amountValue < MIN_AMOUNT_RUB) {
      return {
        type: 'min',
        message: `Минимальная сумма: ${MIN_AMOUNT_RUB.toLocaleString()} ₽`
      };
    }
    
    // Проверка лимитов
    if (currentLimits) {
      const dailyRemaining = currentLimits.daily?.remaining;
      const monthlyRemaining = currentLimits.monthly?.remaining;
      const perTransaction = currentLimits.perTransaction;
      
      const availableLimits = [dailyRemaining, monthlyRemaining, perTransaction].filter(l => l !== undefined && l !== null);
      const maxAvailable = availableLimits.length > 0 ? Math.min(...availableLimits) : null;
      
      if (maxAvailable !== null && amountValue > maxAvailable) {
        return {
          type: 'limit',
          message: `Превышен лимит. Доступно: ${maxAvailable.toLocaleString()} ₽`,
          available: maxAvailable
        };
      }
    }
    
    return null;
  };
  
  const amountValidation = getAmountValidation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-900 to-black flex flex-col">
      <div className="max-w-md mx-auto w-full p-4 pb-8 mt-auto">

        {/* Header */}
        <div className="bg-gray-800/50 rounded-xl p-3 mb-2.5 border border-gray-700/50">
          <div className="flex items-center gap-3">
            <div className="bg-green-500/20 rounded-lg p-2">
              <WeChatIcon className="w-5 h-5" />
            </div>
            <div>
              <h1 className="text-base font-bold text-white">Пополнить WeChat</h1>
              <p className="text-gray-500 text-xs">Создание заявки на пополнение</p>
            </div>
          </div>
        </div>


        {/* Verification Status */}
        {isVerified && <div className={`rounded-xl p-3 mb-2.5 border flex items-center gap-3 ${
          isAdmin
            ? 'bg-purple-500/10 border-purple-500/30'
            : 'bg-green-500/10 border-green-500/30'
        }`}>
          {isAdmin ? (
            <>
              <Star className="w-5 h-5 text-purple-400" />
              <span className="text-sm text-purple-300 font-medium">Администратор</span>
            </>
          ) : (
            <>
              <Shield className="w-5 h-5 text-green-400" />
              <span className="text-sm text-green-300 font-medium">Верификация пройдена</span>
            </>
          )}
        </div>}

        {/* USDT без верификации */}
        {!isVerified && !isVerificationLoading && wechatPaymentMethod === 'USDT' && (
          <div className="bg-emerald-500/10 rounded-xl px-3 py-2 mb-2.5 border border-emerald-500/30 flex items-center gap-2.5">
            <USDTIcon className="w-4 h-4 flex-shrink-0" />
            <p className="text-xs text-emerald-300">Без верификации — не чаще 1 заявки в 5 минут</p>
          </div>
        )}

        {/* Night Time Warning */}
        {isNightTime && <NightTimeWarning />}

        {/* Payment Method Selection */}
        <div className="bg-gray-800/50 rounded-xl p-3 mb-2.5 border border-gray-700/50">
          <h2 className="text-sm font-medium text-gray-400 mb-2">Способ оплаты</h2>
          <div className="grid grid-cols-3 gap-2">
            <button
              onClick={() => {
                setWechatPaymentMethod('RUB_SBP');
                setWechatSelectedBank('');
                setWechatUsdtNetwork('');
                track('deposit_method_selected', { method: 'RUB_SBP' });
              }}
              className={`py-3 px-2 rounded-xl transition-all flex flex-col items-center gap-1.5 ${
                wechatPaymentMethod === 'RUB_SBP'
                  ? 'bg-green-600/20 ring-2 ring-green-500 border-transparent'
                  : 'bg-gray-900/50 hover:bg-gray-800 border border-gray-700/50'
              }`}
            >
              <SBPIcon className="w-7 h-7" />
              <span className={`text-xs font-medium ${wechatPaymentMethod === 'RUB_SBP' ? 'text-green-400' : 'text-gray-400'}`}>СБП</span>
            </button>

            <button
              onClick={() => {
                setWechatPaymentMethod('RUB_VTB');
                setWechatSelectedBank('vtb');
                setWechatUsdtNetwork('');
                track('deposit_method_selected', { method: 'RUB_VTB' });
              }}
              className={`py-3 px-2 rounded-xl transition-all flex flex-col items-center gap-1.5 ${
                wechatPaymentMethod === 'RUB_VTB'
                  ? 'bg-green-600/20 ring-2 ring-green-500 border-transparent'
                  : 'bg-gray-900/50 hover:bg-gray-800 border border-gray-700/50'
              }`}
            >
              <VTBIcon className="w-10 h-5" />
              <span className={`text-xs font-medium ${wechatPaymentMethod === 'RUB_VTB' ? 'text-green-400' : 'text-gray-400'}`}>ВТБ</span>
            </button>

            <button
              onClick={() => {
                setWechatPaymentMethod('USDT');
                setWechatSelectedBank('');
                setWechatUsdtNetwork('');
                track('deposit_method_selected', { method: 'USDT' });
              }}
              className={`relative py-3 px-2 rounded-xl transition-all flex flex-col items-center gap-1.5 ${
                wechatPaymentMethod === 'USDT'
                  ? 'bg-emerald-600/20 ring-2 ring-emerald-500 border-transparent'
                  : 'bg-gray-900/50 hover:bg-gray-800 border border-gray-700/50'
              }`}
            >
              {!isVerified && !isVerificationLoading && (
                <span className="absolute -top-1.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-emerald-500 px-1.5 py-0.5 text-[8px] font-semibold leading-none text-white shadow">
                  Доступно без KYC
                </span>
              )}
              <USDTIcon className="w-7 h-7" />
              <span className={`text-xs font-medium ${wechatPaymentMethod === 'USDT' ? 'text-emerald-400' : 'text-gray-400'}`}>USDT</span>
            </button>
          </div>
        </div>

        {/* Limits Card */}
        {currentLimits && (
          <div className="bg-gray-800/50 rounded-xl p-3 mb-2.5 border border-gray-700/50">
            <h2 className="text-sm font-medium text-gray-400 mb-2 flex items-center gap-2">
              {wechatPaymentMethod === 'RUB_SBP' && <SBPIcon className="w-4 h-4" />}
              {wechatPaymentMethod === 'RUB_VTB' && <VTBIcon className="w-5 h-3" />}
              Лимиты {currentLimits.name}
            </h2>
            <div className="space-y-3">
              <div className="flex items-center justify-between py-1.5 border-b border-gray-700/50">
                <span className="text-gray-400 text-sm">На транзакцию</span>
                <span className="text-white font-medium">{currentLimits.perTransaction?.toLocaleString()} RUB</span>
              </div>
              <div>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-gray-400 text-sm">Дневной</span>
                  <span className="text-white text-sm">
                    {currentLimits.daily?.used?.toLocaleString()} / {currentLimits.daily?.limit?.toLocaleString()} RUB
                  </span>
                </div>
                <div className="w-full h-1.5 bg-gray-700 rounded-full overflow-hidden">
                  <div 
                    className="h-full bg-green-500 rounded-full transition-all"
                    style={{ width: `${Math.min(currentLimits.daily?.percent || 0, 100)}%` }}
                  />
                </div>
              </div>
              <div>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-gray-400 text-sm">Месячный</span>
                  <span className="text-white text-sm">
                    {currentLimits.monthly?.used?.toLocaleString()} / {currentLimits.monthly?.limit?.toLocaleString()} RUB
                  </span>
                </div>
                <div className="w-full h-1.5 bg-gray-700 rounded-full overflow-hidden">
                  <div 
                    className="h-full bg-purple-500 rounded-full transition-all"
                    style={{ width: `${Math.min(currentLimits.monthly?.percent || 0, 100)}%` }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* USDT No Limits Notice */}
        {wechatPaymentMethod === 'USDT' && (
          <div className="bg-emerald-500/10 rounded-xl p-3 mb-2.5 border border-emerald-500/30 flex items-center gap-3">
            <USDTIcon className="w-6 h-6" />
            <div>
              <span className="font-medium text-emerald-400 text-sm">Без лимитов</span>
              <p className="text-xs text-gray-400">На переводы USDT лимиты не распространяются. Минимум — {MIN_AMOUNT_USDT} USDT</p>
            </div>
          </div>
        )}

        {/* Bank Selection for SBP */}
        {wechatPaymentMethod === 'RUB_SBP' && (
          <div className="bg-gray-800/50 rounded-xl p-3 mb-2.5 border border-gray-700/50">
            <h2 className="text-sm font-medium text-gray-400 mb-2">
              {wechatSelectedBank ? 'Выбранный банк' : 'Выберите банк'}
            </h2>
            
            {wechatSelectedBank ? (
              // Показываем выбранный банк с кнопкой отмены
              <div className="bg-green-600/20 rounded-xl p-4 border border-green-500/30 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <Check className="w-5 h-5 text-green-400" />
                  <span className="text-green-400 font-medium">
                    {banks.find(b => (b.id || b.name) === wechatSelectedBank)?.name || wechatSelectedBank}
                  </span>
                </div>
                <button
                  onClick={() => setWechatSelectedBank('')}
                  className="p-1.5 rounded-lg bg-gray-800/50 hover:bg-gray-700 transition-all"
                >
                  <X className="w-4 h-4 text-gray-400" />
                </button>
              </div>
            ) : (
              // Показываем список банков
              <>
                <div className="relative mb-3">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
                  <input
                    type="text"
                    value={bankSearch}
                    onChange={(e) => setBankSearch(e.target.value)}
                    placeholder="Поиск банка..."
                    className="w-full pl-9 pr-4 py-3 bg-gray-900/50 border border-gray-700/50 rounded-xl focus:border-green-500 focus:outline-none transition-all text-white text-sm placeholder-gray-500"
                  />
                </div>
                <div className="bg-gray-900/30 rounded-xl border border-gray-700/30 overflow-hidden max-h-48 overflow-y-auto">
                  {filteredBanks.map((bank, index) => (
                    <button
                      key={bank.id || bank.name}
                      onClick={() => { setWechatSelectedBank(bank.id || bank.name); track('deposit_bank_selected', { bankId: bank.id || bank.name, bankName: bank.name }); }}
                      className={`w-full px-4 py-3 flex items-center justify-between transition-all text-gray-300 hover:bg-gray-800/50 ${
                        index !== filteredBanks.length - 1 ? 'border-b border-gray-800/50' : ''
                      }`}
                    >
                      <span className="text-sm">{bank.name}</span>
                    </button>
                  ))}
                  {filteredBanks.length === 0 && (
                    <div className="px-4 py-6 text-center text-gray-500 text-sm">
                      Банк не найден
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        )}

        {/* USDT Network Selection */}
        {wechatPaymentMethod === 'USDT' && (
          <div className="bg-gray-800/50 rounded-xl p-3 mb-2.5 border border-gray-700/50">
            <h2 className="text-sm font-medium text-gray-400 mb-2">Способ перевода</h2>
            <div className="grid grid-cols-2 gap-3">
              <button
                onClick={() => { setWechatUsdtNetwork('TRC-20'); track('deposit_method_selected', { method: 'USDT', network: 'TRC-20' }); }}
                className={`py-3 px-3 rounded-xl transition-all flex flex-col items-center gap-1.5 ${
                  wechatUsdtNetwork === 'TRC-20'
                    ? 'bg-red-600/20 ring-2 ring-red-500 border-transparent'
                    : 'bg-gray-900/50 hover:bg-gray-800 border border-gray-700/50'
                }`}
              >
                <TronIcon className="w-8 h-8" />
                <div className="text-center">
                  <p className={`text-sm font-medium ${wechatUsdtNetwork === 'TRC-20' ? 'text-red-400' : 'text-gray-300'}`}>TRC-20</p>
                  <p className="text-xs text-gray-500">Сеть TRON</p>
                </div>
              </button>
              <button
                onClick={() => { setWechatUsdtNetwork('Bybit'); track('deposit_method_selected', { method: 'USDT', network: 'Bybit' }); }}
                className={`py-3 px-3 rounded-xl transition-all flex flex-col items-center gap-1.5 ${
                  wechatUsdtNetwork === 'Bybit'
                    ? 'bg-orange-600/20 ring-2 ring-orange-500 border-transparent'
                    : 'bg-gray-900/50 hover:bg-gray-800 border border-gray-700/50'
                }`}
              >
                <BybitIcon className="w-8 h-8" />
                <div className="text-center">
                  <p className={`text-sm font-medium ${wechatUsdtNetwork === 'Bybit' ? 'text-orange-400' : 'text-gray-300'}`}>Bybit</p>
                  <p className="text-xs text-gray-500">Внутренний</p>
                </div>
              </button>
            </div>
          </div>
        )}

        {/* Order Details Form */}
        <div className="bg-gray-800/50 rounded-xl p-3 mb-2.5 border border-gray-700/50">
          <h2 className="text-sm font-medium text-gray-400 mb-2">Детали заявки</h2>

          <div className="space-y-3">
            {/* Amount */}
            <div>
              <label className="block text-sm text-gray-400 mb-1.5">
                {wechatPaymentMethod === 'USDT' ? 'Сумма в USDT' : 'Сумма в рублях (RUB)'}
              </label>
              <input
                type="number"
                value={wechatAmount}
                onChange={(e) => setWechatAmount(e.target.value)}
                onBlur={(e) => { if (e.target.value) track('deposit_amount_entered', { amount: parseFloat(e.target.value) }); }}
                placeholder="Введите сумму"
                className={`w-full px-4 py-3 bg-gray-900/50 border rounded-xl focus:outline-none transition-all text-white placeholder-gray-500 ${
                  amountValidation ? 'border-red-500/50 focus:border-red-500' : 'border-gray-700/50 focus:border-green-500'
                }`}
              />
              
              {/* Предупреждение о лимитах */}
              {amountValidation && (
                <div className="mt-2 flex items-center gap-2 text-sm">
                  <AlertTriangle className="w-4 h-4 text-red-400" />
                  <span className="text-red-400">{amountValidation.message}</span>
                </div>
              )}
              
              {/* Курс конвертации */}
              {wechatAmount && wechatPaymentMethod && !amountValidation && (
                <div className="mt-2 flex items-center gap-2 text-sm">
                  {calculatedAmount?.loading ? (
                    <>
                      <Loader2 className="w-4 h-4 text-green-400 animate-spin" />
                      <span className="text-gray-400">Расчет...</span>
                    </>
                  ) : (
                    <>
                      <TrendingUp className="w-4 h-4 text-green-400" />
                      <span className="text-gray-400">Вы получите:</span>
                      <span className="font-medium text-green-400">
                        {wechatPaymentMethod === 'USDT' 
                          ? `${calculatedAmount?.cny || (parseFloat(wechatAmount) * (usdtToCnyRate || 7.2)).toFixed(2)} CNY`
                          : `${calculatedAmount?.cny || (parseFloat(wechatAmount) / (exchangeRate || 11.74)).toFixed(2)} CNY`}
                      </span>
                    </>
                  )}
                </div>
              )}
            </div>

            {/* Full Name */}
            <div>
              <label className="block text-sm text-gray-400 mb-1.5">Имя и Фамилия (латиницей)</label>
              <input
                type="text"
                value={wechatFullName}
                onChange={(e) => setWechatFullName(e.target.value)}
                placeholder="Ivan Ivanov"
                className="w-full px-4 py-3 bg-gray-900/50 border border-gray-700/50 rounded-xl focus:border-green-500 focus:outline-none transition-all text-white placeholder-gray-500"
              />
              <div className="mt-2 flex items-start gap-2">
                <Shield className="w-4 h-4 text-amber-400 mt-0.5 flex-shrink-0" />
                <p className="text-xs text-amber-400/80">
                  ФИО должны совпадать с данными KYC и картой, с которой производится оплата
                </p>
              </div>
            </div>

            {/* QR Code Upload */}
            <div>
              <label className="block text-sm text-gray-400 mb-1.5">QR код WeChat</label>
              <div className="relative">
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => { setWechatQrCode(e.target.files[0]); if (e.target.files[0]) track('deposit_qr_uploaded'); }}
                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                />
                <div className={`w-full px-4 py-3 rounded-xl border transition-all flex items-center gap-3 ${
                  wechatQrCode 
                    ? 'bg-green-500/10 border-green-500/30' 
                    : 'bg-gray-900/50 border-gray-700/50 hover:border-gray-600'
                }`}>
                  {wechatQrCode ? (
                    <>
                      <Check className="w-5 h-5 text-green-400" />
                      <span className="text-green-400 text-sm truncate">{wechatQrCode.name}</span>
                    </>
                  ) : (
                    <>
                      <Upload className="w-5 h-5 text-gray-500" />
                      <span className="text-gray-500 text-sm">Выберите файл</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Согласия с документами */}
        <div className="bg-gray-800/50 rounded-xl p-3 mb-2.5 border border-gray-700/50">
          <div className="space-y-2.5">
            <label className="flex items-center gap-3 cursor-pointer group p-1.5 rounded-xl hover:bg-gray-700/30 transition-all">
              <div className="relative flex-shrink-0">
                <input
                  type="checkbox"
                  checked={privacyAccepted}
                  onChange={(e) => setPrivacyAccepted(e.target.checked)}
                  className="sr-only"
                />
                <div className={`w-6 h-6 rounded-lg border-2 flex items-center justify-center transition-all ${
                  privacyAccepted 
                    ? 'bg-green-600 border-green-600 shadow-lg shadow-green-600/30' 
                    : 'border-gray-500 group-hover:border-green-400'
                }`}>
                  {privacyAccepted && <Check className="w-4 h-4 text-white" />}
                </div>
              </div>
              <div className="flex-1">
                <span className="text-sm text-gray-200">
                  Я принимаю{' '}
                  <a 
                    href={encodeURI("/Политика конфеденциальности.pdf")}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-green-400 hover:text-green-300 underline font-medium"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Политику конфиденциальности
                  </a>
                </span>
              </div>
            </label>
            
            <div className="border-t border-gray-700/50"></div>
            
            <label className="flex items-center gap-3 cursor-pointer group p-1.5 rounded-xl hover:bg-gray-700/30 transition-all">
              <div className="relative flex-shrink-0">
                <input
                  type="checkbox"
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                  className="sr-only"
                />
                <div className={`w-6 h-6 rounded-lg border-2 flex items-center justify-center transition-all ${
                  termsAccepted 
                    ? 'bg-green-600 border-green-600 shadow-lg shadow-green-600/30' 
                    : 'border-gray-500 group-hover:border-green-400'
                }`}>
                  {termsAccepted && <Check className="w-4 h-4 text-white" />}
                </div>
              </div>
              <div className="flex-1">
                <span className="text-sm text-gray-200">
                  Я принимаю{' '}
                  <a 
                    href={encodeURI("/Пользовательское соглашение.pdf")}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-green-400 hover:text-green-300 underline font-medium"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Пользовательское соглашение
                  </a>
                </span>
              </div>
            </label>
          </div>
        </div>

        {/* Submit Button */}
        {!canCreateOrder ? (
          <button
            onClick={() => setShowKycModal(true)}
            className="w-full bg-green-600 hover:bg-green-500 text-white rounded-xl py-3.5 px-5 font-medium transition-all flex items-center justify-center gap-2"
          >
            <span>Пополнить</span>
            <ArrowRight className="w-5 h-5" />
          </button>
        ) : (
          <button
            onClick={() => setShowChecklist(true)}
            disabled={
              isSubmitting ||
              !wechatPaymentMethod ||
              !wechatAmount ||
              !wechatFullName ||
              !wechatQrCode ||
              (wechatPaymentMethod === 'RUB_SBP' && !wechatSelectedBank) ||
              (wechatPaymentMethod === 'USDT' && !wechatUsdtNetwork) ||
              !privacyAccepted ||
              !termsAccepted ||
              !!amountValidation
            }
            className="w-full bg-green-600 hover:bg-green-500 disabled:bg-gray-700 disabled:cursor-not-allowed text-white rounded-xl py-3.5 px-5 font-medium transition-all flex items-center justify-center gap-2"
          >
            {isSubmitting ? (
              <>
                <Loader2 className="w-5 h-5 animate-spin" />
                <span>Создание заявки...</span>
              </>
            ) : (
              <>
                <span>Создать заявку</span>
                <ArrowRight className="w-5 h-5" />
              </>
            )}
          </button>
        )}
      </div>

      {showChecklist && (
        <div
          className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/70 backdrop-blur-sm p-4"
          onClick={() => setShowChecklist(false)}
        >
          <div
            className="w-full max-w-md bg-gray-900 border border-gray-800 rounded-2xl p-5 max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-white text-lg font-semibold">Проверьте перед отправкой</h3>
              <button
                onClick={() => setShowChecklist(false)}
                className="text-gray-400 hover:text-white"
                aria-label="Закрыть"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="space-y-3">
              <label className="flex items-start gap-3 p-3 bg-gray-800/60 rounded-xl cursor-pointer hover:bg-gray-800">
                <input
                  type="checkbox"
                  checked={checkPhone}
                  onChange={(e) => setCheckPhone(e.target.checked)}
                  className="mt-0.5 w-5 h-5 accent-green-600 cursor-pointer"
                />
                <span className="text-sm text-gray-200">К моему кошельку WeChat привязан телефон</span>
              </label>

              <label className="flex items-start gap-3 p-3 bg-gray-800/60 rounded-xl cursor-pointer hover:bg-gray-800">
                <input
                  type="checkbox"
                  checked={checkVerified}
                  onChange={(e) => setCheckVerified(e.target.checked)}
                  className="mt-0.5 w-5 h-5 accent-green-600 cursor-pointer"
                />
                <span className="text-sm text-gray-200">Мой кошелек WeChat верифицирован</span>
              </label>

              <label className="flex items-start gap-3 p-3 bg-gray-800/60 rounded-xl cursor-pointer hover:bg-gray-800">
                <input
                  type="checkbox"
                  checked={checkQr}
                  onChange={(e) => setCheckQr(e.target.checked)}
                  className="mt-0.5 w-5 h-5 accent-green-600 cursor-pointer"
                />
                <div className="flex-1">
                  <span className="text-sm text-gray-200 block mb-2">Я прикрепил QR нужного формата (как в примере ниже)</span>
                  <img
                    src="/qr-example-wechat.png"
                    alt="Пример QR"
                    className="w-full max-w-[200px] rounded-lg border border-gray-700 bg-white"
                    onError={(e) => { e.currentTarget.style.display = 'none'; }}
                  />
                </div>
              </label>
            </div>

            <div className="flex gap-2 mt-5">
              <button
                onClick={() => setShowChecklist(false)}
                className="flex-1 bg-gray-800 hover:bg-gray-700 text-white rounded-xl py-3 px-4 font-medium transition-all"
              >
                Отмена
              </button>
              <button
                onClick={() => {
                  if (!allChecked) return;
                  setShowChecklist(false);
                  setCheckPhone(false);
                  setCheckVerified(false);
                  setCheckQr(false);
                  handleWechatDeposit();
                }}
                disabled={!allChecked}
                className="flex-1 bg-green-600 hover:bg-green-500 disabled:bg-gray-700 disabled:cursor-not-allowed text-white rounded-xl py-3 px-4 font-medium transition-all"
              >
                Подтвердить
              </button>
            </div>
          </div>
        </div>
      )}

      {showKycModal && (
        <div
          className="fixed inset-0 z-50 flex items-start justify-center bg-black/70 backdrop-blur-sm p-4 pt-24 overflow-y-auto"
          onClick={() => setShowKycModal(false)}
        >
          <div
            className="w-full max-w-md bg-gray-900 border border-gray-800 rounded-2xl p-4 max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-white text-base font-semibold">Нужна верификация KYC</h3>
              <button
                onClick={() => setShowKycModal(false)}
                className="text-gray-400 hover:text-white"
                aria-label="Закрыть"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="bg-emerald-500/10 rounded-xl p-3 mb-2.5 border border-emerald-500/30 flex items-center gap-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 256 256" className="text-emerald-400 flex-shrink-0"><path d="M208,40H48A16,16,0,0,0,32,56v56c0,52.72,25.52,84.67,46.93,102.19,23.06,18.86,46,25.27,47,25.53a8,8,0,0,0,4.2,0c1-.26,23.91-6.67,47-25.53C198.48,196.67,224,164.72,224,112V56A16,16,0,0,0,208,40Zm-48,96H136v24a8,8,0,0,1-16,0V136H96a8,8,0,0,1,0-16h24V96a8,8,0,0,1,16,0v24h24a8,8,0,0,1,0,16Z"></path></svg>
              <span className="text-sm text-emerald-300 font-medium">Остался один шаг до пополнения</span>
            </div>

            <div className="bg-gray-800/50 rounded-xl p-3 mb-2.5 border border-gray-700/50">
              <h2 className="text-xs font-medium text-gray-400 mb-2">Выгода от верификации KYC</h2>
              <div className="space-y-1">
                <div className="flex items-center gap-2.5 py-1.5 border-b border-gray-700/50">
                  <div className="w-1.5 h-1.5 rounded-full bg-green-400 flex-shrink-0" />
                  <span className="text-gray-300 text-sm"><span className="text-white font-medium">Безопасность:</span> Официальные переводы через СБП без риска блокировки карты.</span>
                </div>
                <div className="flex items-center gap-2.5 py-1.5 border-b border-gray-700/50">
                  <div className="w-1.5 h-1.5 rounded-full bg-green-400 flex-shrink-0" />
                  <span className="text-gray-300 text-sm"><span className="text-white font-medium">Скорость:</span> Автоматизация пополнения, кошелёк пополняется за 10 минут.</span>
                </div>
                <div className="flex items-center gap-2.5 py-1.5">
                  <div className="w-1.5 h-1.5 rounded-full bg-green-400 flex-shrink-0" />
                  <span className="text-gray-300 text-sm"><span className="text-white font-medium">Банковский стандарт:</span> 1000+ сделок и 500+ клиентов.</span>
                </div>
              </div>
              <button
                onClick={() => setIsDetailsOpen(!isDetailsOpen)}
                className="flex items-center gap-1.5 mt-3 text-green-400 text-xs font-medium hover:text-green-300 transition-colors"
              >
                <span>Подробнее</span>
                <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-200 ${isDetailsOpen ? 'rotate-180' : ''}`} />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${isDetailsOpen ? 'max-h-[500px] mt-3' : 'max-h-0'}`}>
                <div className="space-y-3 border-t border-gray-700/50 pt-3">
                  <p className="text-gray-300 text-sm leading-relaxed">
                    <span className="text-white font-semibold">Kit8 Exchange</span> работает официально. Мы провели уже более <span className="text-white font-semibold">1000 безопасных сделок</span> для <span className="text-white font-semibold">500+ постоянных клиентов</span>, и наша главная задача — ваша финансовая безопасность.
                  </p>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    <span className="text-white font-semibold">Защита от блокировок:</span> Верификация позволяет нам проводить платежи через СБП официально. Это исключает риск блокировки вашей карты по <span className="text-white font-semibold">115-ФЗ</span>, который часто возникает при обычных P2P-переводах.
                  </p>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    <span className="text-white font-semibold">Скорость:</span> Благодаря верификации появляется возможность проведения сделок автоматизировано, а значит юани поступают на ваш счёт значительно быстрее, чем в других сервисах.
                  </p>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    <span className="text-white font-semibold">Безопасность данных:</span> Информация зашифрована и используется только для подтверждения личности. Мы не храним и не передаём ваши документы третьим лицам.
                  </p>
                  <p className="text-gray-400 text-sm leading-relaxed font-medium">
                    <span className="text-white font-semibold">Итог:</span> Проходя верификацию, вы получаете доступ к по-настоящему безопасным и быстрым переводам в любое время, не рискуя блокировкой своего счёта по ФЗ-115.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-blue-500/10 rounded-xl p-3 mb-2.5 border border-blue-500/30">
              <div className="flex items-start gap-2.5">
                <img src="/beorg-logo.png" alt="Beorg" className="h-5 flex-shrink-0 mt-0.5" />
                <p className="text-sm text-gray-200">Проверка через <span className="font-bold text-white">Beorg</span> — партнёра Банка России и Теле2. Данные шифруются и не хранятся на серверах.</p>
              </div>
            </div>

            <div className="bg-gray-800/50 rounded-xl p-3 mb-3 border border-gray-700/50">
              <h2 className="text-xs font-medium text-gray-400 mb-2">Как пройти верификацию</h2>
              <div className="space-y-1">
                <div className="flex items-center gap-2.5 py-1.5 border-b border-gray-700/50">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-blue-500/20 text-blue-400 text-xs font-bold flex items-center justify-center">1</span>
                  <span className="text-gray-300 text-sm">Введите номер телефона</span>
                </div>
                <div className="flex items-center gap-2.5 py-1.5 border-b border-gray-700/50">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-blue-500/20 text-blue-400 text-xs font-bold flex items-center justify-center">2</span>
                  <span className="text-gray-300 text-sm">Подтвердите личность</span>
                </div>
                <div className="flex items-center gap-2.5 py-1.5">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-blue-500/20 text-blue-400 text-xs font-bold flex items-center justify-center">3</span>
                  <span className="text-gray-300 text-sm">Получите одобрение за несколько минут</span>
                </div>
              </div>
            </div>

            <button
              onClick={() => {
                setShowKycModal(false);
                setProfileActiveSection('kyc');
                setCurrentScreen('profile');
              }}
              className="w-full bg-green-600 hover:bg-green-500 text-white rounded-xl py-3.5 px-5 font-medium text-sm transition-all flex items-center justify-center gap-2"
            >
              <span>Пройти верификацию</span>
              <ArrowRight className="w-4 h-4" />
            </button>

            {/* Альтернатива KYC: USDT доступен без верификации */}
            <button
              onClick={() => {
                setShowKycModal(false);
                setWechatPaymentMethod('USDT');
                setWechatSelectedBank('');
                setWechatUsdtNetwork('');
                setWechatAmount(''); // сумма была в рублях — в USDT её переносить нельзя
                track('deposit_method_selected', { method: 'USDT', from: 'kyc_modal' });
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="w-full mt-2 bg-emerald-600/15 hover:bg-emerald-600/25 border border-emerald-500/40 text-emerald-300 rounded-xl py-3.5 px-5 font-medium text-sm transition-all flex items-center justify-center gap-2"
            >
              <USDTIcon className="w-4 h-4" />
              <span>Оплатить через USDT без KYC</span>
            </button>

            <p className="text-center text-xs text-gray-600/50 mt-2">Технология соответствует требованиям 152-ФЗ «О персональных данных».</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default WechatScreen;
